// Track ordering for the already-enrolled upsell. Kept identical to the
// learning MFE's `CourseModeUpgradeCard/tierHierarchy.ts` so the in-course
// upgrade card and this page agree on what counts as "above" a given track.
export const TIER_ORDER = [
  'honor',
  'audit',
  'verified',
  'professional',
  'no-id-professional',
  'executive-education',
];

const FREE_MODES = new Set(['honor', 'audit']);

// An unknown slug sorts below everything, so a custom track never becomes an
// upgrade target by accident -- authors opt those in via upsellableCourseModes.
export const tierIndex = (slug) => {
  const idx = TIER_ORDER.indexOf(slug);
  return idx === -1 ? -Infinity : idx;
};

export const isPaidMode = (slug) => !FREE_MODES.has(slug);

export const isAbove = (candidate, current) => tierIndex(candidate) > tierIndex(current);
